function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1141.85844 744.6c-22.6 28.4-77.6 48.6-77.6 48.6L654.05844 940.4v-108.6l301.8-107.6c34.2-12.2 39.6-29.6 11.6-38.8-27.8-9.2-78.2-6.6-112.4 5.8L654.05844 762.2v-112.8c46.4-15.6 94.2-27.2 151.4-33.6 81.8-9 181.8 1.2 260.4 31 88.4 28 98.4 69.4 76 97.8z m-448.8-185v-278c0-32.6-6-62.6-36.6-71.2-23.4-7.6-38 14.2-38 46.8v695.8l-187.6-59.6V64c79.8 14.8 196 49.8 258.4 70.8C848.25844 189.4 902.05844 257.4 902.05844 410.4c0 149-92 205.6-209 149.2zM86.45844 820.4c-90.8-25.6-106-79-64.6-109.6 38.2-28.4 103.4-49.8 103.4-49.8l269-95.6v109l-193.6 69.2c-34.2 12.2-39.4 29.6-11.6 38.8 27.8 9.2 78.2 6.6 112.4-5.8l92.8-33.8v97.6c-103.2 18.6-202.8 14.6-307.8-20z",
  fill: "",
  "p-id": 5696
});

function SvgPlaystation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1602691204153,
    className: "icon",
    viewBox: "0 0 1152 1024",
    "p-id": 5695,
    width: 225,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystation);
export default __webpack_public_path__ + "static/media/playstation.dc2b957d.svg";
export { ForwardRef as ReactComponent };